import { ActionFunctionArgs, redirect } from "react-router-dom";
import { api, wrappedCollectionFetcher } from "services/api.service";
import { LabelColor } from "types/locationManagement/labelColor";
import { defaultLocationManagementLocationType } from "types/locationManagement/locationType";
import { withActionErrorAlert } from "utils/withActionError";
import { withAuth } from "routes/utils/withAuth";

export const loader = withAuth(async () => {
  const labelColors = await wrappedCollectionFetcher<LabelColor>("/location_management/label_colors?page[size]=100");
  return { locationType: defaultLocationManagementLocationType, labelColors: labelColors.rows || [] };
});

export async function action({ request }: ActionFunctionArgs) {
  const fd = await request.formData();
  const res = await withActionErrorAlert(() =>
    api.request({
      method: "POST",
      url: `/location_management/location_types`,
      data: fd,
      headers: { "Content-Type": "multipart/form-data" },
    }),
  );
  if (res?.status === 201) {
    return redirect("/location-types");
  }
  return res;
}
